import { render, staticRenderFns } from "./DormantAfterTrialSettings.vue?vue&type=template&id=bb01cece&scoped=true"
import script from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js"
export * from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js"
import style0 from "./DormantAfterTrialSettings.vue?vue&type=style&index=0&id=bb01cece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb01cece",
  null
  
)

export default component.exports